/**
 * EmptyState — Sprint-16-Brand.
 *
 * 3-Zeilen-Pattern: Icon + Serif-Headline + Description + Next-Action-Button.
 * Für Operations-UI immer mit Next-Action — leere Screens sind Einladungen zu
 * handeln, nicht bloße Zustands-Meldungen.
 */
import type { ReactNode } from 'react';
import { Button, type ButtonProps } from './Button';
import { I, type IconName } from '@/shared/icons';

export interface EmptyStateProps {
  icon?: IconName;
  title: ReactNode;
  description?: ReactNode;
  action?: {
    label: string;
    onClick: () => void;
    variant?: ButtonProps['variant'];
    size?: ButtonProps['size'];
    leftIcon?: ReactNode;
  };
}

export function EmptyState({ icon = 'Inbox', title, description, action }: EmptyStateProps) {
  return (
    <div className="col-span-full flex flex-col items-center justify-center p-16 text-center">
      <div className="text-ink-faint mb-3">
        <I name={icon} size={32} strokeWidth={1.6} />
      </div>
      <h3 className="text-ink font-serif text-xl">{title}</h3>
      {description && <p className="text-ink-soft mt-2 max-w-md text-sm">{description}</p>}
      {action && (
        <Button
          variant={action.variant ?? 'brand'}
          size={action.size}
          leftIcon={action.leftIcon}
          onClick={action.onClick}
          className="mt-6"
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
